<template>
  <div>
    <b-modal
      id="modal-attach-reference"
      size="lg"
      ok-title="Save"
      cancel-title="Cancel"
      class="h-100 test"
      hide-header
      centered
      no-close-on-backdrop
    >
      <div class="d-flex">
        <h5 @click="close()" class="ms-auto" style="font-size: 1.5rem">x</h5>
      </div>
      <div class="d-flex flex-column justify-content-center h-100">
        <div class="my-auto">
          <div class="d-flex justify-content-center">
            <div
              style="max-height: 65vh"
              class="w-75 d-flex justify-content-center"
            >
              <img
                v-if="img == null"
                src="@/assets/mobile/fillin/attach.png"
                alt="attach"
                class="w-100"
                style="max-width: 250px"
              />
              <img
                v-else
                :src="img"
                alt="file"
                class=""
                id="file-upload"
                style="max-width: 100%; max-height: 100%"
              />
            </div>
          </div>
        </div>
        <div v-if="img == null" class="advice-box mb-3 p-3">
          <p class="fs-6 mb-0">คำแนะนำเอกสาร</p>
          <p class="fs-6">
            สามารถเลือกวิธีอัพโหลดเอกสารได้แค่ 1 ครั้ง
            กรุณาเลือกวิธีการอัพโหลดเอกสาร ถ่ายรูปเอกสารอ้างอิง หรือแนบใบเสร็จ
            .JPEG
          </p>
        </div>
      </div>

      <template #modal-footer>
        <div class="row w-100">
          <div
            class="col-6 text-center border-end border-dark cursor-pointer"
            @click="openModalCamera()"
          >
            <p class="mb-0">
              <i class="fa fa-camera" aria-hidden="true"></i>
            </p>
            <p>ถ่ายรูป</p>
          </div>
          <div class="col-6 file-input text-center">
            <input
              id="file"
              ref="file"
              type="file"
              class="file-link cursor-pointer"
              @change="onFileChange"
            />
            <label class="label-button-upload-attach cursor-pointer" for="file">
              <p class="mb-0">
                <i class="fa-regular fa-image"></i>
              </p>
              <p>แนบเอกสาร</p>
            </label>
          </div>
          <div
            class="col-12 text-center d-flex justify-content-center align-items-center"
          >
            <button
              class="btn border border-dark px-5 mt-2 rounded-pill"
              @click="close()"
            >
              ตกลง
            </button>
          </div>
          <!-- <div class="col-6 text-center cursor-pointer" @click="onFileChange()">
            <p class="mb-0">
              <i class="fa-regular fa-image"></i>
            </p>
            <p>แนบเอกสาร</p>
          </div> -->
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import helper from "../../mixins/helper";
export default {
  props: {
    imgUpload: {
      type: [String, Object, File, Array],
      default: null,
    },
    isDeleteImg: {
      type: Boolean,
      default: false,
    },
    isResetImg: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [helper],
  data() {
    return {
      img: null,
      type: null,
      fileUpload: null,
      compressedImageBlob: null,
    };
  },
  watch: {
    imgUpload: "setImgUpload",
    isDeleteImg: "deleteImg",
    isResetImg: "resetImg",
  },
  methods: {
    deleteImg() {
      if (this.isDeleteImg == true) {
        this.fileUpload = null;
        this.url = null;
        this.img = null;
      }
    },

    resetImg() {
      this.fileUpload = null;
      this.url = null;
      this.img = null;
    },

    openModalCamera() {
      this.type = "camera";
      this.$emit("openModalCamera");
    },
    setImgUpload(img) {
      if (img) {
        if (this.checkOnlyImage(img)) {
          this.img = img.file.file_url;
        } else {
          if (
            this.checkTypeFile(img.file) != "xls" &&
            this.checkTypeFile(img.file) != "xlsx" &&
            this.checkTypeFile(img.file) != "pdf"
          ) {
            this.img = URL.createObjectURL(img);
          }
        }
      }
    },
    checkTypeFile(data) {
      if (data) {
        var parts = data.name.split(".");
        return parts[parts.length - 1];
      }
    },
    close() {
      this.$bvModal.hide("modal-attach-reference");
      if (this.type == "upload") {
        this.$emit("imageUpload", this.fileUpload);
      }
      this.type = null;
    },
    onFileChange(e) {
      this.type = "upload";

      if (e.target.files[0]) {
        let fileType = this.$refs.file.files[0].type;
        this.fileUpload = this.$refs.file ? this.$refs.file.files[0] : null;
        if (
          fileType == "image/jpeg" ||
          fileType == "image/png" ||
          fileType == "image/jpg"
        ) {
          //image
          this.img = URL.createObjectURL(this.fileUpload);
        } else {
          //file
          this.img = null;
        }
      }
    },
    resizeImage(e) {
      this.type = "upload";
      if (e.target.files[0]) {
        this.fileUpload = this.$refs.file ? this.$refs.file.files[0] : null;
        // this.img = URL.createObjectURL(this.fileUpload);

        const reader = new FileReader();

        reader.addEventListener("load", () => {
          this.openImage(reader.result);
          // this.openImage(e.target.files[0]);
        });

        reader.readAsDataURL(e.target.files[0]);
      }
    },

    openImage(imageSrc) {
      // console.log('b64toBlob',this.dataUrlToBlob(imageSrc));

      let canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      this.activeImage = new Image();
      this.activeImage.addEventListener("load", () => {
        let originalWidth = this.activeImage.width;
        let originalHeight = this.activeImage.height;
        let canvaWidth = 0;
        let canvaHeight = 0;

        if (originalWidth > originalHeight) {
          //รูปแนวนอน
          if (originalWidth > 1920) {
            canvaWidth = 1920;
            canvaHeight = 1080;
          } else {
            canvaWidth = originalWidth;
            canvaHeight = originalHeight;
          }
        } else {
          //รูปแนวตั้ง
          if (originalWidth > 1920) {
            canvaWidth = 1080;
            canvaHeight = 1920;
          } else {
            canvaWidth = originalWidth;
            canvaHeight = originalHeight;
          }
        }
        // set size proportional to image

        canvas.width = canvaWidth;
        canvas.height = canvaHeight;
        ctx.drawImage(this.activeImage, 0, 0, canvaWidth, canvaHeight);

        // let compressedImageBlob = null;

        canvas.toBlob(
          (blob) => {
            if (blob) {
              console.log("blob", blob);
              this.img = URL.createObjectURL(blob);
              this.compressedImageBlob = blob;
              console.log("compressedImageBlobIN", this.compressedImageBlob);
            }
          },
          "image/png",
          0.8
        );

        console.log("compressedImageBlob", this.compressedImageBlob);

        // let dataurl = canvas.toDataURL(this.activeImage);

        // let dataurl = canvas.toDataURL(this.activeImage);
        // console.log("dataurlxxx", dataurl);
      });
      this.activeImage.src = URL.createObjectURL(this.dataUrlToBlob(imageSrc));
    },

    dataUrlToBlob(url) {
      const arr = url.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const str = atob(arr[1]);
      let length = str.length;
      const uintArr = new Uint8Array(length);
      while (length--) {
        uintArr[length] = str.charCodeAt(length);
      }
      console.log(
        "new Blob([uintArr], { type: mime }",
        new Blob([uintArr], { type: mime })
      );
      return new Blob([uintArr], { type: mime });
    },
  },
};
</script>
<style lang="scss">
#modal-attach-reference .modal-dialog {
  height: 100% !important;
}
#modal-attach-reference .modal-content {
  height: 100% !important;
}
#modal-attach-reference {
  --bs-modal-margin: 0 !important;
  --bs-modal-border-color: white;
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0;
}

.modal-footer {
  border-top: none !important;
}

.file-link {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}

.file-input .label-button-upload-attach {
  color: black;
}

.advice-box {
  border: 1px solid #91d5ff;
  background: #e6f7ff;
}

@media (min-width: 768px) {
  .advice-box {
    width: 75%;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
